// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3F-XN","messages":"Chat_messages__sZIH5","dateDivider":"Chat_dateDivider__1xLth"};